import React, { Fragment, useContext } from 'react'
import { Box, GridItem, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { MediaType } from 'enums/media'
import get from 'lodash/get'
import pick from 'lodash/pick'
import MultiCarousel from 'components/MultiCarousel'
import { getMedia } from 'components/pages/DetailPage/utils'
import { IProperty } from 'interfaces/property'
import { IRoomDefaultValue } from 'interfaces/roomDefaultValue'
import { IUnitWithRelations } from 'interfaces/unit'
import { getValidArray, prependHTTPSToUrl } from 'utils/common'
import { ApplicationContext } from '../../../../applicationForm.context'
import { MainWrapper, RoomWrapper, RoomWrapperMobile } from './chooseBedroom.styles'
import RoomCard, { IRoomCardProps } from './components/RoomCard'
import styles from './chooseBedroom.module.scss'

const ChooseBedroom = () => {
  const { houseDetail, chosenUnitId, setChosenUnitId } = useContext(ApplicationContext)
  const roomList: IUnitWithRelations[] = getValidArray(houseDetail?.units ?? [])
  const isMoreRooms: boolean = roomList?.length > 1
  const { media = [] } = houseDetail ?? ({} as IProperty)
  const defaultRoom: IRoomDefaultValue = {} as IRoomDefaultValue
  const videoUrl: string = get(getMedia(media, MediaType.VIDEO), '[0].url', '')
  const vrUrl: string = get(getMedia(media, MediaType.VR), '[0].url', prependHTTPSToUrl(videoUrl))

  function getRoomCardProps(room: IUnitWithRelations, defaultRoomValue: IRoomDefaultValue): IRoomCardProps {
    return {
      ...pick(room, 'price', 'name', 'id', 'availableStartDate', 'availableEndDate', 'buildiumUnitId', 'media'),
      availableDate: room?.listing?.availableDate,
      houseMedia: media,
      defaultRoomValue,
      setChosenUnitId: typeof setChosenUnitId === 'function' ? setChosenUnitId : () => {},
      isChosen: chosenUnitId === room?.buildiumUnitId,
      vrUrl: room?.vrTourUrl ?? vrUrl
    }
  }

  return (
    <VStack spacing={{ base: 2, lg: 4 }} alignItems="flex-start" width="full">
      <Text fontSize="md" lineHeight={6} fontWeight={500} color="gray.700">
        Choose Bedroom
      </Text>
      <MainWrapper>
        <GridItem
          rowStart={{ base: 2, lg: 1 }}
          display={{ base: 'flex', md: 'block' }}
          flexDirection={{ base: 'column', md: 'unset' }}
          width="full"
        >
          <RoomWrapper>
            {roomList.map((room: IUnitWithRelations) => (
              <Fragment key={room.id}>
                <RoomCard {...getRoomCardProps(room, defaultRoom)} />
              </Fragment>
            ))}
          </RoomWrapper>
          <RoomWrapperMobile>
            {!isMoreRooms ? (
              <Box minHeight={{ base: 180, lg: 360 }}>
                <RoomCard {...getRoomCardProps(roomList[0], defaultRoom)} isFullWidth={true} />
              </Box>
            ) : (
              <MultiCarousel
                className={styles.sliderFrame}
                slidesToShow={1.2}
                showArrows={false}
                showDots={false}
                dragging={true}
              >
                {getValidArray<IUnitWithRelations>(roomList).map((room: IUnitWithRelations, index: number) => {
                  return (
                    <SimpleGrid key={index} columns={1} marginRight={3}>
                      <RoomCard {...getRoomCardProps(room, defaultRoom)} isFullWidth={false} />
                    </SimpleGrid>
                  )
                })}
              </MultiCarousel>
            )}
          </RoomWrapperMobile>
        </GridItem>
      </MainWrapper>
    </VStack>
  )
}

export default ChooseBedroom
